import Vue from 'vue'
import App from './App.vue'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import VueCurrencyInput from 'vue-currency-input'
import VueRouter from 'vue-router';
import CalculationForm from './components/CalculationForm.vue';
import Fondovi from './components/FondoviEU.vue';
import Clanak from './components/Clanak.vue';

Vue.use(VueRouter)
const routes = [{
    path: '/',
    name: 'CalculationForm',
    component: CalculationForm,
  },
  {
    path: '/fondovi',
    name: 'fondovi',
    component: Fondovi,
  },
  {
    path: '/clanak',
    name: 'clanak',
    component: Clanak,
  },
]

const router = new VueRouter({
  routes // short for `routes: routes`
})

const pluginOptions = {
  /* see config reference */
  globalOptions: {
    currency: 'HRK',
    locale: 'de'
  }
}
Vue.use(VueCurrencyInput, pluginOptions)
Vue.use(Chartkick.use(Chart))

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('hr-HR', {
    style: 'currency',
    currency: 'hrk',
  });
  return formatter.format(value);
});